function enableTableSearch({
  inputRef,
  tableRef,
  columnIndex = 0,
  noDataText = "No results found",
}) {
  if (!inputRef?.current || !tableRef?.current) return;

  const handleSearch = () => {
    const searchQuery = inputRef.current.value.toLowerCase();
    const rows = tableRef.current.getElementsByTagName("tr");

    let found = false;

    const noDataRow = tableRef.current.querySelector("tr td[colspan]");
    if (noDataRow) {
      tableRef.current.removeChild(noDataRow.parentElement);
    }

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].getElementsByTagName("td");
      if (!cells[columnIndex]) continue;

      const cellText = cells[columnIndex].textContent.toLowerCase();

      if (cellText.includes(searchQuery)) {
        rows[i].style.display = "";
        found = true;
      } else {
        rows[i].style.display = "none";
      }
    }

    if (!found && rows.length > 0) {
      const noDataRow = document.createElement("tr");
      const noDataCell = document.createElement("td");
      noDataCell.colSpan = rows[0].getElementsByTagName("td").length;
      noDataCell.textContent = noDataText;
      noDataCell.style.textAlign = "center";
      noDataRow.appendChild(noDataCell);
      tableRef.current.appendChild(noDataRow);
    }
  };

  inputRef.current.addEventListener("input", handleSearch);

  return () => {
    if (inputRef.current) {
      inputRef.current.removeEventListener("input", handleSearch);
    }
  };
}

export default enableTableSearch;
